export default "__VITE_ASSET__5q4Hw6VH__"